import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

type AILanguageSelectorStyleProps = {};

const styles = {
  root: css`
    position: relative;
    display: inline-flex;
  `,

  dropdownMenu: css`
    z-index: 3;
  `,
} satisfies Styles<AILanguageSelectorStyleProps>;

export const useStyles = withStyles(styles);
